/* eslint-env browser */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import PasswordWrapperComponent from './components/PasswordWrapperComponent';

// Get the application-wide store instance,
// prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

const rootElement = document.querySelector('main');
ReactDOM.render(
  <Provider store={store}>
    <PasswordWrapperComponent />
  </Provider>,
  rootElement,
);
